module.exports = __webpack_public_path__ + "img/WEB-AD-1.856c1770.jpg";